
import { type InviteFormValues } from "./types";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const inviteSchema = z.object({
  email: z.string().email(),
});

export const InviteMemberForm = ({ 
  onSubmit,
  isLoading,
  isPro 
}: { 
  onSubmit: (values: InviteFormValues) => Promise<void>;
  isLoading: boolean;
  isPro: boolean;
}) => {
  const form = useForm<InviteFormValues>({
    resolver: zodResolver(inviteSchema),
    defaultValues: {
      email: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Invite Team Member</FormLabel>
              <FormControl>
                <div className="flex gap-4">
                  <Input
                    {...field}
                    type="email"
                    placeholder="team@example.com"
                    className="flex-1"
                  />
                  <Button type="submit" disabled={isLoading || !isPro}>
                    {isLoading ? "Inviting..." : "Send Invite"}
                  </Button>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};
